module.exports = __webpack_public_path__ + "static/img/unnamed (1).5c9e53a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/unnamed (1).png
// module id = v9cq
// module chunks = 3